<label class="radio-label">
  <input type="radio" class="radio" [name]="name" [value]="value" [checked]="isChecked" [disabled]="disabled"
    (change)="onRadioChange($event)" />
  @if (label) {
  <span class="radio-text">{{ label }}</span>
  }
  <ng-content></ng-content>
</label>